import { Section } from "../Global/Section";
import { Content } from "../Global/Content";
import { motion } from "framer-motion";
import {
  LayoutType,
  LinkType,
  DividerType,
  OptionsType,
} from "../../utils/baseTypes";
import Divider from "../Divider/Divider";

interface TextLayoutType extends LayoutType {
  modul_size: "small" | "normal";
}

export type TextModuleType = {
  acf_fc_layout: "text";
  text: {
    headline: string;
    htype_tag: "h2" | "h3";
    subline?: string;
    content?: string;
    link: LinkType;
    cta_type: "link" | "berlinfahrten-form" | "contact-form";
    button_label: string;
    divider: DividerType;
  };
  layout: TextLayoutType;
};

interface TextProps {
  data: TextModuleType;
  type: string;
  options: OptionsType;
}

const Text = ({ data, type, options }: TextProps) => {
  const {
    modul_size,
    hpos_class,
    tpos_class,
    abstand,
    background,
    ctapos_class,
    number_cols,
    id,
  } = data.layout;

  const gap = abstand === "default" ? "" : abstand;
  const {
    headline,
    htype_tag,
    link,
    content,
    divider,
    subline,
    cta_type,
    button_label,
  } = data.text;
  const maxWidth =
    number_cols === "one-column" && hpos_class !== "headline-beside-text"
      ? "max-width"
      : "normal-width";

  const variantsText = {
    visible: {
      opacity: 1,
      y: 0,
    },
    hidden: {
      opacity: 0,
      y: 50,
    },
  };

  return (
    <Section
      className={`text ${
        type !== "encyclopedia" ? "divider" : ""
      } ${background} ${gap}`}
      id={id}
      columnsClassName="is-multiline is-centered"
    >
      {divider && divider.divider_on && (
        <div className="column is-12">
          <Divider data={divider} background={background} />
        </div>
      )}

      <div
        className={`column is-12-tablet ${
          type === "encyclopedia"
            ? "is-8-widescreen"
            : modul_size === "small"
            ? "is-9-widescreen"
            : "is-12-widescreen"
        } ${maxWidth}`}
      >
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          variants={variantsText}
          transition={{
            ease: [0.455, 0.03, 0.515, 0.955],
            duration: 0.85,
          }}
        >
          <Content
            hpos={hpos_class ?? ""}
            tpos={tpos_class ?? ""}
            htype={htype_tag}
            headline={headline}
            subline={subline}
            text={content ?? ""}
            link={link}
            ctapos={ctapos_class ?? ""}
            number_cols={number_cols ?? ""}
            cta_type={cta_type}
            button_label={button_label}
            options={options}
          />
        </motion.div>
      </div>
    </Section>
  );
};

export default Text;
